export const logisticKpiHeader = [
  {
    group: 'Data',
    columns: [
      {
        name: 'Execução',
        id: 'data-execucao-id',
        show: false
      }
    ]
  },
  {
    group: 'CD/Loja',
    columns: [
      {
        name: 'Código',
        id: 'cd-loja-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'cd-loja-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Gerente',
    columns: [
      {
        name: 'Categoria',
        id: 'gerente-categoria-id',
        show: false
      },
      {
        name: 'Produto',
        id: 'gerente-produto-id',
        show: false
      }
    ]
  },
  {
    group: 'Categoria Compacta',
    columns: [
      {
        name: 'Código',
        id: 'categoria-compacta-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'categoria-compacta-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Sub Categoria',
    columns: [
      {
        name: 'Código',
        id: 'subcategoria-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'subcategoria-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Empresa',
    columns: [
      {
        name: 'Código',
        id: 'empresa-codigo-id',
        show: false
      },
      {
        name: 'Nome',
        id: 'empresa-nome-id',
        show: false
      }
    ]
  },
  {
    group: 'Fornecedor',
    columns: [
      {
        name: 'ID',
        id: 'fornecedor-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Descrição',
        id: 'fornecedor-descricao-id',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Quantidade',
    columns: [
      {
        name: 'Pedidos',
        id: 'quantidade-pedidos-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'SKUs Por Pedido',
        id: 'quantidade-sku-pedido-id',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Recebimentos (%)',
    columns: [
      {
        name: 'Antes Do Prazo',
        id: 'recebimentos-antes-prazo-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'No Prazo',
        id: 'recebimentos-prazo-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Depois Do Prazo',
        id: 'recebimentos-depois-prazo-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Parciais',
        id: 'recebimentos-parciais-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'In-Full',
        id: 'recebimentos-in-full-id',
        show: true,
        isNumeric: true
      }
    ]
  },
  {
    group: 'Lead Time',
    columns: [
      {
        name: 'Cadastrado (Dias)',
        id: 'lead-time-cadastrado-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Realizado (Dias)',
        id: 'lead-time-realizado-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Desvio (Dias)',
        id: 'lead-time-desvio-id',
        show: true,
        isNumeric: true
      },
      {
        name: 'Desvio (%)',
        id: 'lead-time-porc-desvio-id',
        show: true,
        isNumeric: true
      }
    ]
  }
]
